import { memo, useTransition } from "react";

import {
	FilterInSaleAndStopSellingForLaptop,
	FilterInSaleAndStopSellingForMobile,
} from "@/components/features/items/stock/_shared/components/filter/filter-insale-and-stop-selling/components";
import { useIsSideMenuMobileRendered } from "@/components/features/side-menu/mobile";

import type { DisplayFilterItems } from "../../model/build-display-filter-items";

type Props = {
	planFilterItems: DisplayFilterItems;
	roomFilterItems: DisplayFilterItems;
	selectedPlanIDs: string[];
	selectedRoomIDs: string[];
	onChangePlanIDs: (value: string[]) => void;
	onChangeRoomIDs: (value: string[]) => void;
};

/**
 * 在庫ページと同じ「表示するプラン／部屋」チェック（PC）／セレクト（モバイル）。
 * 人数セレクトは年月と横並びするため api-section 側に置く。
 */
export const PlanRateMatrixFilterBar = memo(
	({
		planFilterItems,
		roomFilterItems,
		selectedPlanIDs,
		selectedRoomIDs,
		onChangePlanIDs,
		onChangeRoomIDs,
	}: Props) => {
		const isMobile = useIsSideMenuMobileRendered();
		const [isPlanFilterPending, startPlanFilterTransition] = useTransition();
		const [isRoomFilterPending, startRoomFilterTransition] = useTransition();

		const FilterComponent = isMobile
			? FilterInSaleAndStopSellingForMobile
			: FilterInSaleAndStopSellingForLaptop;

		return (
			<div className="flex flex-col gap-y-4">
				<FilterComponent
					isPending={isPlanFilterPending}
					itemsName="プラン"
					selectedItemIDs={selectedPlanIDs}
					onChangeSelectedItemIDs={(ids) => {
						startPlanFilterTransition(() => {
							onChangePlanIDs(ids);
						});
					}}
					inSaleItems={planFilterItems.inSaleItems}
					stopSellingItems={planFilterItems.stopSellingItems}
				/>

				<FilterComponent
					isPending={isRoomFilterPending}
					itemsName="部屋"
					selectedItemIDs={selectedRoomIDs}
					onChangeSelectedItemIDs={(ids) => {
						startRoomFilterTransition(() => {
							onChangeRoomIDs(ids);
						});
					}}
					inSaleItems={roomFilterItems.inSaleItems}
					stopSellingItems={roomFilterItems.stopSellingItems}
				/>
			</div>
		);
	},
);

PlanRateMatrixFilterBar.displayName = "PlanRateMatrixFilterBar";
